import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';

import Brand from 'models/brand';

const propTypes = {
  brand: PropTypes.instanceOf(Brand).isRequired,
};

export const defaultProps = {
};

class HelpInfo extends Component {
  renderMonthlyInstructions() {
    if (!this.props.booking.monthlyPricing) {
      return null;
    }

    const { monthlyPricing } = this.props.booking;
    const contactInformation = monthlyPricing.contactInformation ? <p>{monthlyPricing.contactInformation}</p> : null;
    const instructions = monthlyPricing.instructions ? <p>{monthlyPricing.instructions}</p> : null;
    const details = monthlyPricing.description ? <p>{monthlyPricing.description}</p> : null;

    let instructionsSection;
    if (contactInformation || instructions) {
      instructionsSection = (
        <div>
          <h3 className="h3 top">Redemption Instructions</h3>
          {instructions}
          {contactInformation}
        </div>
      );
    }

    let detailsSection;
    if (details) {
      detailsSection = (
        <div>
          <h3 className="h3 top">Monthly Parking Details</h3>
          {details}
        </div>
      );
    }

    return (
      <div>
        {instructionsSection}
        {detailsSection}
      </div>
    );
  }

  renderTip() {
    if (this.props.booking.type === 'monthly_booking') {
      return this.renderMonthlyInstructions();
    }

    if (this.props.brand.hideReceiptCTAs) { return null; }
    return (
      <div>
        Tip: You can make changes to this booking by signing into the <a href="/account">My Account</a> page before you park.
      </div>
    );
  }

  render() {
    return (
      <div className="help-info">
        {this.renderTip()}
        <div>
          <h6 className="h6">NEED HELP?</h6>
          We'd love to help you any way we can! Visit our help center at <a href={this.props.brand.helpWebsiteURL} target="_blank" className="dark-link">{this.props.brand.helpWebsiteURL}</a>, text us at <a href={`"sms:${this.props.brand.helpPhone}"`} className="dark-link">{this.props.brand.helpPhone}</a>, or email us at <a href={`"mailto:${this.props.brand.helpEmail}"`} className="dark-link">{this.props.brand.helpEmail}</a>
        </div>
      </div>
    );
  }
}

HelpInfo.propTypes = propTypes;
HelpInfo.defaultProps = defaultProps;
export default HelpInfo;
